export default "__VITE_ASSET__BklYZFht__"